import React from 'react';
import './Banner.scss';
import icon from '../../assets/banner/icons/Calling.png';
import bannerImg from '../../assets/banner/1.png';
import bannerPattern from '../../assets/banner/pattern_02.png';
import shapeOne from '../../assets/banner/vector_01.png';
import shapeTwo from '../../assets/banner/vector_02.png';
import shapeThree from '../../assets/banner/vector_03.png';
import shapeFour from '../../assets/banner/pattern.png';

const Banner = () => {
    return (
        <section className='section-bg section-common banner-section' aria-labelledby="banner-heading">
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="banner-text" data-aos="fade-up" data-aos-duration="2000">
                                    <h1 id="banner-heading">Entrust your smile to professionals</h1>
                                    <p>Big Smiles Start Here – Making Dentistry Comfortable and Fun with Dr. Mishqah Dollie in Ottery, Cape Town.</p>

                                    <div className="banner-bottom">
                                        <div className="theme-btn">
                                            <a href="https://www.recomed.co.za/dentist/cape-town/mishqah-dollie/7579/7349/" 
                                               target="_blank" 
                                               rel="noopener noreferrer"
                                               aria-label="Book an appointment with Dr Mishqah Dollie">
                                                Book an appointment
                                            </a>
                                        </div>

                                        <div className="banner-call" role="complementary" aria-label="Emergency contact information">
                                            <div className='icon'>
                                                <img src={icon} alt="Emergency phone icon" />
                                            </div>
                                            <div className='call-text'>
                                                <p>Emergency</p>
                                                <h6>
                                                    <a href="tel:+27649144852" aria-label="Call emergency number 064 914 4852">064 914 4852</a> | <a href="tel:+27217039149" aria-label="Call office number 021 703 9149">021 703 9149</a>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="banner-img-area" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                    <div className="banner-img">
                                        <img src={bannerImg} alt="Dr Mishqah Dollie - Professional dentist in Ottery, Cape Town" />
                                    </div>
                                    

                                    {/* Vector Shapes */}
                                    <div className="shapes" aria-hidden="true">
                                        <img src={shapeOne} alt="" />
                                        <img src={shapeTwo} alt="" />
                                        <img src={shapeThree} alt="" />
                                        <img src={shapeFour} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Banner Pattern Vector*/}
            <img className='banner-pattern' src={bannerPattern} alt="" aria-hidden="true" />
        </section>
    );
};

export default Banner;